import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { createBEMClasses } from '@/utils/classname';

import IllustrationEmptySearch from './IllustrationEmptySearch';

import './WorkshopListEmptyState.css';

const { block } = createBEMClasses('workshop-list-empty-state');

const WorkshopListEmptyState = ({ emptyStateText }: { emptyStateText: string }) => (
  <Stack gap="16px" alignItems="center" className={block()}>
    <IllustrationEmptySearch />
    <Paragraph>{emptyStateText}</Paragraph>
  </Stack>
);

export default WorkshopListEmptyState;
